// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".voting-results li{display:block;margin-bottom:.5rem}.voting-results table{width:100%;margin:0;margin:initial;border-collapse:collapse}.voting-results table tr td,.voting-results table tr th{border-bottom:1px solid #ccc;padding:12px}.voting-results table>tfoot{font-weight:bold}", ""]);
// Exports
module.exports = exports;
